import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MonthYearService {
  private monthSource = new BehaviorSubject<number>(new Date().getMonth() + 1);
  private yearSource = new BehaviorSubject<number>(new Date().getFullYear());

  month$ = this.monthSource.asObservable();
  year$ = this.yearSource.asObservable();

  setMonthAndYear(month: number, year: number): void {
    this.monthSource.next(month);
    this.yearSource.next(year);
  }
}
